
import { defineComponent } from 'vue';

const YEAR = new Date().getFullYear();

export default defineComponent({
  name: 'AppFooter',
  props: {
    copyright: {
      type: String,
      default: `Copyright © ${YEAR} 广州致景信息科技有限公司`,
    },
  },
});
